export default __webpack_public_path__ + "static/media/assigned.03a5b7dc.png";